export default __webpack_public_path__ + "static/media/loc-black.3875d117.png";